// extracted by mini-css-extract-plugin
export default {"fullWidth":"AccessManagement_fullWidth__pB0ye"};